<template>
  <section class="custom-file-document">
    <div class="row custom-file-host">
      <div
        v-if="isUpload"
        :ref="`fileDragDrop_${name}`"
        class="row custom-drag-drop"
        draggable="true"
        @dragover.prevent="onDrag"
        @dragleave="onDragLeave"
        @drop="handleDrop"
      >
        <div class="col">
          <input
            :ref="`fileUploader_${name}`"
            type="file"
            multiple
            :id="`file-uploader_${folder}`"
            class="custom-file-upload"
            @change="handleFileInput"
            accept=".pdf,.doc,.xls,.jpg,.jpeg,.png"
          />

          <label :for="`file-uploader_${folder}`" class="custom-drag-drop-label">
            <i class="fa-solid fa-upload"></i> Drag & Drop or <span class="custom-choose-file">Choose file</span> to upload
          </label>
        </div>
      </div>
      <div class="custom-file-list-wrapper">
        <div class="row custom-file-list">
          <div v-if="isUpload && (isVisible || isLoading)">
            <Loader documents="true" />
          </div>
        </div>
        <div v-if="!isVisible && !isLoading">
          <div class="custom-file-list" v-for="(tData, index) in currentFiles" :key="index">
            <div v-if="isNameUpdate" class="row">
              <div class="col">
                <div class="input-group">
                  <span class="input-group-text">Name:</span>
                  <input type="text" class="form-control" v-model="tData.altname" @change="changedName(tData.name)" />
                </div>
              </div>
              <div class="col-1 text-center">
                <button class="custom-file-delete" tabindex="-1" @click="confirmDeleteFile(tData.name)">
                  <i class="fa-solid fa-trash"></i>
                </button>
              </div>
            </div>
            <div class="row">
              <div class="col custom-file-link">
                <a v-if="isShowFile(tData)" @click="showFile(tData)">
                  {{ tData.name }}
                </a>
              </div>
              <div v-if="tData.type === 'file' && !isNameUpdate" class="col-1 text-center">
                <button class="custom-file-delete" tabindex="-1" @click="confirmDeleteFile(tData.name)">
                  <i class="fa-solid fa-trash"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="noData === true && !isLoading" class="custom-file-list-none">
        <Loader emptyDocuments="true" :nothingFound="nothingFound" />
      </div>
    </div>
  </section>
  <DialogPreview :show="actionConfirm" modalSize="modal-sm">
    <template v-slot:body>
      <div>
        <span>Are you sure you want to delete?</span>
      </div>
    </template>
    <template v-slot:footer>
      <button type="button" class="btn btn-primary px-4" @click="performFileDeletion(fileToDelete)">Delete</button>
      <button type="button" class="btn btn-secondary px-4" data-bs-dismiss="modal" @click="closeModal">Cancel</button>
    </template>
  </DialogPreview>
  <DialogPreview :show="actionPreview" modalSize="modal-xl">
    <template v-slot:header>
      <div class="row" style="width: 100%">
        <div class="col">
          <span class="custom-title">Preview</span>
          <span class="float-end" data-bs-dismiss="modal" @click="closeModal">
            <i class="fa fa-close" aria-hidden="true"></i>
          </span>
        </div>
      </div>
    </template>
    <template v-slot:body>
      <div v-if="isLoading">
        <span>loading...</span>
      </div>
      <div v-else-if="isError" class="custom-error">
        <div class="row">
          <div class="col">
            <span>{{ errorMessage }}</span>
          </div>
        </div>
        <div v-if="isAnyJson" class="row">
          <div class="col">
            <json-viewer v-show="isAnyJson" :value="jsondata" copyable />
          </div>
        </div>
      </div>
      <object v-else width="100%" :height="height" :data="previewContent" :type="mimeType"></object>
    </template>
    <template v-slot:footer>
      <button type="button" class="btn btn-primary px-4" data-bs-dismiss="modal" @click="closeModal">Okay</button>
    </template>
  </DialogPreview>
  <DialogPreview :show="uploadFailed" modalSize="modal-sm">
    <template v-slot:body>
      <div>
        <span>File is not uploaded, Please try again</span>
      </div>
    </template>
    <template v-slot:footer>
      <button type="button" class="btn btn-primary px-4" data-bs-dismiss="modal" @click="closeModal">Okay</button>
    </template>
  </DialogPreview>
</template>
<script>
import { mapState, mapActions } from 'pinia'
import { authStore } from '@/stores/auth'
import { dashboardStore } from '@/stores/dashboard'
import { opportunityStore } from '@/stores/opportunity'
import { fileStore } from '@/stores/file'
import axios from 'axios'
import DialogPreview from '@/components/utilities/elements/Dialog.vue'
import Loader from '@/components/utilities/elements/Loader.vue'
import { JsonViewer } from 'vue3-json-viewer'
import 'vue3-json-viewer/dist/index.css'
const apiUrl = window.config ? window.config.apiUrl : ''
export default {
  name: 'AppDocuments',
  components: {
    DialogPreview,
    Loader,
    JsonViewer
  },
  props: {
    title: String,
    name: String,
    vin: String,
    refId: String,
    folder: String,
    type: String,
    isShowScans: {
      type: Boolean,
      default: false
    },
    isRepairNetwork: {
      type: Boolean,
      default: false
    },
    nothingFound: String,
    isUpload: {
      type: Boolean,
      default: false
    },
    isNameUpdate: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isVisible: true,
      saveFilesUrl: `${apiUrl}/data/uploadFiles`,
      fileToDelete: null,
      actionConfirm: null,
      actionPreview: null,
      previewContent: null,
      isLoading: false,
      uploadFailed: null,
      mimeType: 'application/pdf',
      height: '100%',
      isError: false,
      errorMessage: null,
      jsondata: null,
      isAnyJson: false
    }
  },
  watch: {
    vin() {
      console.log('VIN Changed', {
        vin: this.vin,
        id: this.refId
      })
      if (this.refId !== null && this.refId !== undefined) {
        this.getFiles({
          firm: this.firmId,
          folder: this.folder,
          vin: this.currentVin,
          id: this.refId
        }).then(() => {
          this.isVisible = false
        })
      }
    }
  },
  computed: {
    ...mapState(authStore, ['token']),
    ...mapState(dashboardStore, ['firm']),
    ...mapState(fileStore, ['fileData']),
    firmId() {
      let _data = null
      if (this.firm) {
        _data = this.firm.firm
      }
      return _data
    },
    currentFiles() {
      let _files = []
      if (this.fileData) {
        _files = this.fileData[this.folder]
      }
      if (typeof _files === 'undefined') {
        _files = []
      }
      return _files
    },
    noData() {
      let _is = false
      if (this.currentFiles.length === 0) {
        _is = true
      }
      return _is
    },
    currentVin() {
      return this.vin
    }
  },
  methods: {
    ...mapActions(fileStore, ['getFiles', 'deleteFile', 'getFile']),
    ...mapActions(opportunityStore, ['pushToAdasMap', 'updateRequestFile']),
    closeModal() {
      this.actionConfirm = null
      this.actionPreview = null
      this.uploadFailed = null
      this.isError = false
      this.errorMessage = null
    },
    isShowFile(file) {
      let _is = true
      if (!this.isShowScans && file.type === 'scan') {
        _is = false
      }
      return _is
    },
    async handleFileInput() {
      this.isLoading = true
      const element = this.$refs[`fileUploader_${this.name}`]
      const file = element.files
      await this.saveFiles(file)
    },
    async handleDrop(event) {
      this.isLoading = true
      event.preventDefault()
      const element = this.$refs[`fileDragDrop_${this.name}`]
      if (element) {
        element.classList.remove('file-active-drag')
      }
      const selectedFile = event.dataTransfer.files
      await this.saveFiles(selectedFile)
    },
    onDrag(event) {
      event.preventDefault()
      const element = this.$refs[`fileDragDrop_${this.name}`]
      if (element) {
        element.classList.add('file-active-drag')
      }
    },
    onDragLeave(event) {
      event.preventDefault()
      const element = this.$refs[`fileDragDrop_${this.name}`]
      if (element) {
        element.classList.remove('file-active-drag')
      }
    },
    async changedName(name) {
      let file = this.currentFiles.find((x) => x.name === name)
      let data = {
        filename: name,
        name: file.altname,
        opportunity: this.refId
      }
      await this.updateRequestFile(data)
    },
    async saveFiles(files) {
      const CancelToken = axios.CancelToken
      const source = CancelToken.source()
      for (let idx = 0; idx < files.length; idx++) {
        const file = files[idx]
        axios({
          method: 'post',
          url: this.saveFilesUrl,
          data: {
            files: file,
            folder: this.folder,
            vin: this.vin,
            firm: this.firmId,
            id: this.refId,
            name: null
          },
          cancelToken: source.token,
          headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: `Bearer ${this.token}`
          }
        })
          .then(() => {
            this.pushToAdasMap(this.refId)
            this.getFiles({
              firm: this.firmId,
              folder: this.folder,
              vin: this.currentVin,
              id: this.refId
            }).then(() => {
              this.isLoading = false
            })
          })
          .catch((thrown) => {
            if (axios.isCancel(thrown)) {
              this.uploadFailed = true
              console.log('Request canceled', thrown.message)
            } else {
              this.uploadFailed = true
              console.log(thrown)
            }
          })
      }
    },
    encodeFileUrl(url) {
      const urlParts = url.split('/') // Split URL by "/"
      const fileName = urlParts.pop() // Extract the last part (file name)
      const encodedFileName = encodeURIComponent(fileName) // Encode the file name
      return urlParts.join('/') + '/' + encodedFileName // Reconstruct the URL
    },
    async showFile(file) {
      try {
        this.isLoading = true
        this.isError = false
        this.errorMessage = null
        this.jsondata = null
        this.previewContent = null
        this.actionPreview = false
        console.log('File', file)
        if (file.url.indexOf('.blob.') > 0) {
          console.log('PDF File', file.name.indexOf('.pdf'))
          if (file.name.toUpperCase().indexOf('.PDF') > 0) {
            this.actionPreview = true
            try {
              if (file.name.toUpperCase().indexOf('.PDF') > 0) {
                this.mimeType = 'application/pdf'
              }
              this.height = '650px'
              const encodedUrl = this.encodeFileUrl(file.url)
              console.log('Encoded URL', encodedUrl)
              const response = await fetch(encodedUrl)
              if (!response.ok) {
                this.errorMessage = `Failed to fetch PDF: ${response.statusText}`
              }
              const blob = await response.blob()
              const fixedBlob = new Blob([blob], { type: this.mimeType })
              // Create a local URL for the blob
              this.previewContent = URL.createObjectURL(fixedBlob)
            } catch (error) {
              this.isError = true
              this.errorMessage = error.message || 'An error occurred while loading the PDF.'
            } finally {
              this.isLoading = false
            }
          } else {
            window.open(file.url, '_blank')
          }
          this.isLoading = false
        } else {
          if (file.name.indexOf('.pdf') > 0) {
            this.actionPreview = true
          }
          console.log('Getting File', file)
          let response = await this.getFile(file.url)
          console.log('Got File i', response)
          if (response) {
            this.isLoading = false
            if (response.error) {
              this.previewContent = null
              this.isError = true
              this.errorMessage = `IW/AutoLogic Error: ${response.error}`
            } else {
              if (file.name.indexOf('.pdf') > 0) {
                if (response.DriveSafeScanPDF === null) {
                  this.isError = true
                  this.errorMessage = 'No PDF content found'
                  if (response.scan_json) {
                    this.jsondata = response.scan_json
                    this.isAnyJson = true
                  }
                  return
                } else {
                  this.mimeType = 'application/pdf'
                  this.height = '650px'
                  this.previewContent = null
                  const blob = this.base64ToBlob(response.DriveSafeScanPDF)
                  this.previewContent = URL.createObjectURL(blob)
                  // this.previewContent = `<object width="100%" height="100%" data="data:application/pdf;base64,${response.DriveSafeScanPDF}" type="application/pdf" class="internal">`
                  // this.previewContent += `<embed src="data:application/pdf;base64,${response.DriveSafeScanPDF} type="application/pdf" /></object>`
                }
              } else {
                this.mimeType = 'application/octet-stream'
                const responseText = response
                const blob = this.base64ToBlob(responseText)
                const blobURL = URL.createObjectURL(blob)
                const a = document.createElement('a')
                document.body.appendChild(a)
                a.href = blobURL
                a.download = file.name
                a.click()
                URL.revokeObjectURL(blobURL)
              }
            }
          }
        }
      } catch (error) {
        console.error('Error:', error)
        this.isLoading = false
      }
    },
    base64ToBlob(base64) {
      const binaryString = atob(base64)
      const arrayBuffer = new ArrayBuffer(binaryString.length)
      const uint8Array = new Uint8Array(arrayBuffer)

      for (let i = 0; i < binaryString.length; i++) {
        uint8Array[i] = binaryString.charCodeAt(i)
      }
      return new Blob([uint8Array], { type: this.mimeType })
    },
    confirmDeleteFile(filename) {
      this.fileToDelete = filename
      this.actionConfirm = true
      console.log('confirm file to delete', this.fileToDelete)
    },
    async performFileDeletion(filename) {
      console.log('perform file to delete', filename)
      this.isLoading = true
      this.actionConfirm = null
      let data = {
        folder: this.folder,
        filename: filename,
        id: this.refId
      }
      await this.deleteFile(data)
      this.pushToAdasMap(this.refId)
      await this.getFiles({
        firm: this.firmId,
        folder: this.folder,
        vin: this.currentVin,
        id: this.refId
      }).then(() => {
        this.isLoading = false
      })
    },
    cleanFilename(data) {
      console.log('Cleaning Filename', data)
      const matches = data.match(/\d\/(.+)$/)
      if (matches && matches.length > 1) {
        return matches[1]
      } else {
        return null
      }
    },
    updateFileName(filename) {
      let data = {
        filename: filename,
        name: null,
        opportunity: this.refId
      }
      console.log('Updating File Name', data)
      // await this.updateRequestFile(data)
    }
  }
}
</script>
<style lang="scss" scoped>
.custom-file-document {
  height: 250px;
}
.custom-file-host {
  border: 1px solid #e8eaf1;
  border-radius: 5px;
  overflow: hidden;
  padding: 5px;
}
.custom-title {
  font-size: 1.2em;
  font-weight: 500;
}
.file-active-drag {
  background-color: #abcfa3;
}
.custom-drag-drop {
  border: 2px dashed;
  border-color: #e8eaf1;
  border-radius: 6px;
  font-size: 1em;
  padding: 10px;
  margin-top: 5px;
  margin-left: 10px;
  width: 98%;
  margin-bottom: 10px;
  text-align: center;
}
.custom-choose-file {
  color: #0eba45;
}
.custom-choose-file:hover {
  cursor: pointer;
}
.custom-file-list-wrapper {
  overflow: auto;
  max-height: 300px;
}
.custom-drag-drop-label {
  font-size: 0.9em;
  font-weight: 500;
  margin-left: 5px;
}
.custom-file-upload {
  width: 0;
  opacity: 0;
  overflow: hidden;
}
.custom-file-list {
  border-radius: 6px;
  width: 100%;
}
.custom-file-link {
  cursor: pointer;
  display: flex;
  align-items: left;
  font-size: 0.9em;
  min-height: 45px;
  a {
    padding: 10px;
    width: 100%;
  }
}
.custom-file-delete {
  position: relative;
  border: 1px solid #e8eaf1;
  color: rgb(133, 0, 0);
  border-radius: 5px;
  top: 5px;
  font-size: 0.9em;
}
.custom-file-list-none {
  text-align: center;
  max-height: 150px;
  height: 100%;
  font-style: italic;
}
.custom-preview {
  min-height: 550px;
  height: 550px;
}
.custom-error {
  overflow-x: hidden;
  overflow-y: auto;
  max-height: 450px;
}
</style>
